import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class vignettesList_template extends vnTemplate {
  protected filter: filterSimple_template;
  protected resultInfos: resultsInfo_template;
  protected pagination: pagination_template;
  protected brandFilter: multipleSelector_template;
  protected statusFilter: multipleSelector_template;


    protected getTemplateHtml(): string {

        return /*html*/ `

          <div class="sub-header w-justify">
            <div class="w-left" >
              <button data-bind=" click: onClickAdd" class="btn secondary icon i-add" type="button">Add Vignette</button>
               ${this.brandFilter.getHtmlBuild()}
               ${this.statusFilter.getHtmlBuild()}
            </div>

            <div class="w-center"><div class="w-filters-search" style="margin-bottom: 2rem;">${ this.filter.getHtmlBuild() }</div></div>

            <div class="w-right">
              ${this.pagination.getHtmlBuild()}
            </div>
          </div>
          <div class="w-filters-selected" style="margin-bottom: 3rem;">
            <div id="filters-selected" class="filters-selected">
                <div id="selected-brands"></div>
                <div id="selected-statuses"></div>
            </div>
          </div>

          <div class="w-list-results" id="list-results">
            <table class="list-results">
                ${this.resultInfos.getHtmlBuild()}
                <thead>
                    <tr>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandOwner') }, css: { 'list-sort-desc': orderByAndDirection()=='brandOwner_DESC', 'list-sort-asc': orderByAndDirection()=='brandOwner_DESC' }">Brand</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Creation Date</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Update Date</span></th>
                    </tr>
                </thead>
                <tbody data-bind="foreach: vignettes">
                    <tr class="cursor" >
                        <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                        <td data-bind="event: { click: $parent.onClickView }">
                            <a class="right-click" data-bind="attr: { href : emakiView }">
                                <!-- ko if: brandOwner -->
                                <span data-bind="attr: { class: brandOwner.iconImage + ' dark square-icon' }"></span>
                                <!-- /ko -->
                            </a>
                        </td>
                        <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: name"></span></a></td>
                        <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span></a></td>
                        <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated"></span></a></td>
                    </tr>
                </tbody>
            </table>
          </div>
        `;
    }

    protected initPartial(): void {
      this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
      this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
      this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
      this.pagination.getTemplateViewModel().itemPerPage = 25;

      this.brandFilter = new multipleSelector_template("brandFilter", this.getTemplateViewModel(), this.caller);
      this.brandFilter.setLabel("Brands");
      this.brandFilter.setFilterContainerClass('margin-neg');
      this.brandFilter.setTagContainerId('selected-brands');
      this.brandFilter.setTagContainerCaption('Selected brands:');

      this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
      this.statusFilter.setLabel("Status");
      this.statusFilter.setFilterContainerClass('margin-neg');
      this.statusFilter.setTagContainerId('selected-statuses');
      this.statusFilter.setTagContainerCaption('Selected status:');
      this.statusFilter.setItems([
        { id: 1, name: 'Draft' },
        { id: 2, name: 'Completed' },
      ]);
    }

    protected getTemplateName(): string {
        return "vignettesList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        const self = this;
        return {
          idBrand: ko.observable(null),
          isAddButtonShown: ko.observable(true),
          orderBy: ko.observable("name"),
          orderByDirection: ko.observable("ASC"),
          orderByAndDirection: ko.observable("name_ASC"),
          vignettes: ko.observableArray([]),
          onClickAdd: () => {
              self.onClickAdd();
          },
          onClickReorder: function (value, data, event) {
            self.onClickReorder(value, data, event);
          },
          onClickView: function (data, event) {
            self.onClickView(data.id);
          }
        };
    }

    public onClickAdd(){

        this.caller.addVignette();
    }

    public onClickView(id){
      this.caller.viewVignette(id);
    }

    public onClickReorder(value, data, event) {

      data.orderBy(value);
      //if column has already been sorted, flip the direction
      if (data.orderByAndDirection().includes(value)) {
          if (data.orderByDirection() == "DESC") {
              data.orderByDirection("ASC");
          } else {
              data.orderByDirection("DESC");
          }
      } else {
          //default column sort direction
          data.orderByDirection("DESC");
      }

      data.orderByAndDirection(value + "_" + data.orderByDirection());

      this.caller.filterList();
  }

  public setVignettes(vignettes) {
      let brandId = this.getIdBrand();
      vignettes.forEach((v) => v['emakiView'] = '/brand/' + brandId + '/categorization/vignettes/view/' + v.id);
      this.getTemplateViewModel().vignettes(vignettes);
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
          pagination: this.getTemplateViewModel().pagination,
          orderBy: this.getTemplateViewModel().orderBy,
          orderByDirection: this.getTemplateViewModel().orderByDirection,
          orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
          filters      : {
            keyword : this.getTemplateViewModel().filter.filterKeyword,
            ownerBrandItems: this.brandFilter.getSelectedItems(),
            idStatus: this.statusFilter.getSelectedItems(),
          },
        }
    }

    public setIdBrand(idBrand): void {

        this.getTemplateViewModel().idBrand(idBrand);
    }

    public getIdBrand() {

        return this.getTemplateViewModel().idBrand();
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

      this.resultInfos.setExecutionTime(execTime);
      this.resultInfos.setNbResults(nbResults);
      this.resultInfos.setNbPages(nbPages);
  }

  public setBrands(brands) {

    this.brandFilter.setItems(brands);
  }

  public setViewModelFromRequest(urlParams){

    //check if URL has filters or user preferences
    if (urlParams != null){
        this.setFilterSelectedItems(this.brandFilter, urlParams.ownerBrandItems);
        this.setFilterSelectedItems(this.statusFilter, urlParams.idStatus);
    }
  }

  public setFilterSelectedItems(objFilter, urlParams){

      let splitString = [];

      // Multi select filters.
      if(urlParams){
          if(typeof urlParams == "string"){
              splitString = urlParams.split(",");
          }else if(Array.isArray(urlParams)){
              splitString = urlParams;
          }else{
              splitString = [urlParams];
          }
          let arrayParam = [];
          let idTagArray = [];
          splitString.forEach((id) => {
              if(!isNaN(Number(id))){
                  id = Number(id);
              }else{
                  id = id.replaceAll("+", " ");
              }
              arrayParam.push({ id: id });
              idTagArray.push(id);
          });
          objFilter.setSelectedItems(arrayParam);
          objFilter.setTags(idTagArray, objFilter.getItems());
      }else{
          objFilter.setSelectedItems([]);
          objFilter.setTags([], objFilter.getItems());
      }
  }

}



// WEBPACK FOOTER //
// ./js/components/templates/vignettesList_template.ts